<template>
  <el-dialog title="Produkte" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th class="nowrap">Name</th>
              <th class="text-center nowrap">Artikel auf Lager</th>
              <th class="text-center nowrap">Einkaufspreis (netto)</th>
              <th class="text-center nowrap">Verkaufspreis</th>
              <th class="text-center nowrap">EK Gesamt</th>
              <th class="text-center nowrap">VK Gesamt</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td v-text="product.name"></td>
              <td class="text-right">{{ product.quantity }}</td>
              <td class="text-right">{{ product.einkaufspreis | priceFromCentEuro }}</td>
              <td class="text-right">{{ product.verkaufspreis | priceFromCentEuro }}</td>
              <td class="text-right">{{ product.einkaufspreis * product.quantity | priceFromCentEuro }}</td>
              <td class="text-right">{{ product.verkaufspreis * product.quantity| priceFromCentEuro }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Summe:</strong></td>
              <td class="text-right"><strong>{{ quantitySum }}</strong></td>
              <td colspan="2"></td>
              <td  class="text-right"><strong>{{ ekSum | priceFromCentEuro }}</strong></td>
              <td  class="text-right"><strong>{{ vkSum | priceFromCentEuro }}</strong></td>
            </tr>
          </tfoot>
        </table>
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  components: { [Dialog.name]: Dialog },
  props: ['show', 'products'],
  computed: {
    quantitySum () {
      return this.products.reduce((sum, { quantity }) => sum + +quantity, 0)
    },
    ekSum () {
      return this.products.reduce((sum, { einkaufspreis, quantity }) => sum + (+einkaufspreis * quantity), 0)
    },
    vkSum () {
      return this.products.reduce((sum, { verkaufspreis, quantity }) => sum + (+verkaufspreis * quantity), 0)
    }
  }
}
</script>

<style>
</style>
